module.exports = __webpack_public_path__ + "media/images/admin/icons/git-merge-bea3f02bc551620cdd8bd56cd51e1d88.svg";